import _ from 'lodash';
import template from './addRcu.modal.html';

/* @ngInject */
function AddRcuModalController(
  $scope,
  $uibModalInstance,
  growl,
  RcuService,
  currentRcu,
  GroupService,
  GroupsButtonService
) {
  const vm = this;
  const edit = Boolean(currentRcu);
  // if currentRcu is being edited, it should be merged later, this ensures it is object
  currentRcu = currentRcu || {};

  // PUBLIC METHODS //
  vm.save = save;
  vm.close = close;
  vm.powerCyclingIsRCU = powerCyclingIsRCU;

  // PUBLIC VARIABLES //
  vm.rcu = angular.copy(currentRcu) || {};
  vm.rcu.protocol = _.isString(vm.rcu.protocol) ? vm.rcu.protocol : 'http'; // Default to HTTP
  vm.rcu.kind = _.isString(vm.rcu.kind) ? vm.rcu.kind : 'PHYSICAL'; // Default to physical
  vm.modalTitle = currentRcu?.name ? `Edit Rcu ${currentRcu.name}` : 'Add New Rcu';

  const powerOptionsValues = [
    {
      name: 'Web Relay',
      value: 'webRelay'
    },
    {
      name: 'Assign as reboot',
      value: 'reboot'
    },
    {
      name: 'RCU',
      value: 'rcu'
    },
    {
      name: 'Click PLC',
      value: 'plc'
    },
    {
      name: 'None',
      value: 'none'
    }
  ];

  vm.powerOptions = powerOptionsValues.sort((powerOptA, powerOptB) => powerOptA.name.localeCompare(powerOptB.name));

  vm.eventHandlingOptions = [
    {
      name: 'Active',
      value: 'ACTIVE',
    },
    {
      name: 'Paused',
      value: 'PAUSED',
    }
  ];

  vm.familyOptions = [
    {
      name: 'UIG - Universal Internet Gateway',
      value: 'UIG',
    },
    {
      name: 'FSU - Fixed Surveillance Unit',
      value: 'FSU',
    },
    {
      name: 'MSU - Mobile Surveillance Unit',
      value: 'MSU',
    },
    {
      name: 'SW - Site Watch',
      value: 'SW',
    },
    {
      name: 'SWE - Site Watch Express',
      value: 'SWE',
    },
    {
      name: 'RoR - RCU on Rails (Server)',
      value: 'RoR',
    },
    {
      name: 'Other',
      value: 'other',
    }
  ];

  // vm.rcu.settings.powerCycling can be undefined if powerCycling has never been set
  vm.rcu.settings = _.defaults(vm.rcu.settings, { powerCycling: _.find(vm.powerOptions, ['name', 'None']).value });
  _.defaults(vm.rcu, { monitoring: true, connectionType: 'DIGI', eventHandling: 'ACTIVE', build: {} });

  vm.rcu.settings.powerCycleRCU = vm.rcu.settings.powerCycleRCU || '192.168.1.250';

  vm.equipmentModalInfo = {
    message: ''
  };
  // group selection
  vm.editGroups = {
    editState: false,
    groupTree: []
  };
  vm.groupList = [];


  // Clean up ip and port when virtual is selected
  $scope.$watch(() => vm.rcu.kind, (newValue, oldValue) => {
    if (newValue === oldValue) { // ignore initial run
      return;
    }
    if (newValue === 'VIRTUAL') {
      vm.rcu.ip = null;
      vm.rcu.port = null;
      vm.rcu.settings.powerCycling = vm.powerOptions[4].value;
      vm.rcu.monitoring = false;
      vm.rcu.connectionType = 'OTHER';
    } else {
      vm.rcu.ip = _.get(currentRcu, 'ip', null);
      vm.rcu.port = _.get(currentRcu, 'port', null);
      vm.rcu.settings.powerCycling = vm.powerOptions[0].value;
      vm.rcu.monitoring = vm.rcu.monitoring || true;
      vm.rcu.connectionType = vm.rcu.connectionType || 'DIGI';
    }
  });
  vm.$onInit = () => {
    $scope.$watch(() => vm.updatedOrg, () => {
      const id = vm.updatedOrg;
      if (id) {
        GroupService.getGroupByOrg(id).then(({ body }) => {
          vm.groupList = [body];
        }).catch((error) => {
          growl.error(error, { title: 'Could not get groups for selected organization' });
        });
      }
    });
  };

  vm.selectedGroups = currentRcu && currentRcu.groups ? angular.copy(currentRcu.groups) : [];

  function powerCyclingIsRCU() {
    return _.get(vm, ['rcu', 'settings', 'powerCycling']) === 'rcu';
  }

  function save() {
    let hasError = false;
    if (vm.rcu.port) {
      vm.rcu.port = Number(vm.rcu.port);
    }
    if (vm.rcu.settings.powerCycling === 'rcu') {
      if (vm.rcu.settings.powerCycleRCU === vm.rcu.ip) {
        growl.error('RCU Address and Power cycling Address cannot be identical.');
        hasError = true;
      }
    } else {
      delete vm.rcu.settings.powerCycleRCU;
    }
    if (!vm.updatedOrg) {
      growl.error('Please select organization.');
      hasError = true;
    }
    const newGroups = GroupsButtonService.rebuildSelectedGroups();
    const selectedGroupIds = _.map(newGroups, sg => ({ id: sg.id }));
    if (!selectedGroupIds.length) {
      growl.error('Please select a group.');
      hasError = true;
    }

    if (hasError) {
      return;
    }

    currentRcu.groups = selectedGroupIds;
    vm.rcu.groups = _.values(selectedGroupIds);
    vm.rcu.org = vm.updatedOrg;
    if (edit) {
      let growlMessage = growl.info('Saving RCU...', { disableCloseButton: true });
      RcuService.updateRcu(vm.rcu.id, vm.rcu)
        .then((success) => {
          angular.merge(currentRcu, success.data[0]);
          growlMessage.destroy();
          growlMessage = growl.success('Save RCU Successful.');
          $uibModalInstance.close();
        })
        .catch((res) => {
          growlMessage.destroy();
          growlMessage = growl.error(res.error, { title: 'Error while saving:' });
        });
    } else {
      let growlMessage = growl.info('Adding RCU...', { disableCloseButton: true });
      RcuService.addNewRcu(vm.rcu)
        .then((createdRcu) => {
          growlMessage.destroy();
          growlMessage = growl.success('RCU successfully added.');
          createdRcu.body.equipment = [];
          $uibModalInstance.close(createdRcu.body);
        })
        .catch((res) => {
          growlMessage.destroy();
          growlMessage = growl.error(res.error, { title: 'Error while saving:' });
        });
    }
  }

  function close() {
    $uibModalInstance.dismiss('close');
  }
}

export default {
  template,
  controller: AddRcuModalController,
  controllerAs: 'AddRcuModCtrl'
};
